"use strict";

class UnitIndexBackupController {

    constructor($scope, $window, $filter, Upload, SSHttpService, SSConfigService, SSAlertService, SSUtilService, OTPService, SSAppService, NgTableParams, SSAwsService, SSUserService, SSAnalyticsService, SSConfirmationService) {
        const self = this;

        self.$scope = $scope;
        self.$window = $window;
        self.filter = $filter;

        self.Upload = Upload;
        self.NgTableParams = NgTableParams;

        self.SSHttpService = SSHttpService;
        self.SSConfigService = SSConfigService;
        self.SSAlertService = SSAlertService;
        self.SSUtilService = SSUtilService;
        self.OTPService = OTPService;
        self.SSAppService = SSAppService;
        self.SSAwsService = SSAwsService;
        self.SSUserService = SSUserService;
        self.SSAnalyticsService= SSAnalyticsService;
        self.SSConfirmationService = SSConfirmationService;

        self.data = SHOWSUITE.data;

        self.UNIT_STATUS_DRAFT = SHOWSUITE.UNIT_STATUS_DRAFT;
        self.UNIT_STATUS_LISTED = SHOWSUITE.UNIT_STATUS_LISTED;
        self.UNIT_STATUS_RESERVED = SHOWSUITE.UNIT_STATUS_RESERVED;
        self.UNIT_STATUS_BOOKED = SHOWSUITE.UNIT_STATUS_BOOKED;
        self.UNIT_STATUS_SOLD = SHOWSUITE.UNIT_STATUS_SOLD;
        self.UNIT_STATUS_SPECIAL_RESERVED = SHOWSUITE.UNIT_STATUS_SPECIAL_RESERVED;

        // Units Import
        self.importParams = {};
        self.unitsDataFileProcessed = false;
        self.unitsImageFilesProcessed = false;
        self.unitAssets = {};
        // Units Import

        if (self.SSUserService.isDeveloper()) {
            self.init();
        }
    }

    init() {
        const self = this;
        self.select_status=[];
        self.search_types=[];
        self.search_categories=[];
        self.search_price_types=[];
        self.search_floorPlan=[];
        self.selectedAgency= [];

        self.sortColumn = 'block_no';
        self.reverseSort = false;

        self.unit_status = 0;

        self.offset = 0;
        self.limit = 10;
        self.selectedPage = 1;

        self.current = 1;

        self.pageChanged = function(newPage) {
            self.loadUnits(newPage);
            // self.loadUnits(newPage);
        };

        self.unitStatuses = [];
        self.edited_fields= [];
        self.editableStatus = [
            self.UNIT_STATUS_DRAFT,
            self.UNIT_STATUS_LISTED,
            self.UNIT_STATUS_SOLD,
            self.UNIT_STATUS_SPECIAL_RESERVED
        ];

        self.OPTIONS_MAP=[
            {"id": "2", "value":  "Category"},
            {"id": "3", "value":  "Type"},
            {"id": "4", "value":  "Name"},
            {"id": "5", "value": "Price"},
            {"id": "6", "value": "Status"},
            {"id": "7", "value": "Commission/Incentives"},
        ];

        self.PRICE_MAP=[
            {"id": "1", "value":  "Fixed Price"},
            {"id": "2", "value":  "Increase By Percentage"},
            {"id": "3", "value":  "Increase By Price"},
            {"id": "4", "value": "Decrease By Price"},
        ];

        self.limit=10;
        self.types = self.SSConfigService.serverConfig.unit_types;
        self.categories= self.SSConfigService.serverConfig.unit_categories;
        self.price_types= self.SSConfigService.serverConfig.unit_price_types;



        if (!self.data.property_id)
            return;

        let url = 'properties/' + self.data.property_id + '/floorplans';

        let params = {
            'property_id': self.data.property_id
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.floorPlans = response.data.floorplans;

            jQuery.each(self.floorPlans, function (i, status) {

                // if(self.search_floorPlan.indexOf({id:status.name, title:status.name}) !== -1)
                // {
                //
                // }else
                // {
                self.search_floorPlan.push({id: status.name, title: status.name});
                //}
            });

        });



        jQuery.each(self.SSConfigService.serverConfig.unit_statuses, function (i, status) {
            if (self.editableStatus.indexOf(status.id) != -1) {
                self.unitStatuses.push(status);
                self.select_status.push({id:status.name, title:status.name});
            }
        });

        jQuery.each(self.types, function (i, status) {
                self.search_types.push({id:status.name, title:status.name});
        });
        jQuery.each(self.categories, function (i, status) {
            self.search_categories.push({id:status.name, title:status.name});
        });


        jQuery.each(self.price_types, function (i, status) {
            self.search_price_types.push({id:status.name, title:status.name});
        });


        self.modifyChanges = false;
        self.params = {
            property_id: self.data.property_id,
            status: self.unitStatuses[0]
        };

        self.param = {
            property_id: self.data.property_id
        };
        self.checkboxes = {
            checked: false,
            count: 0,
            items: {}
        };



        self.getProperty();

        self.getFloorPlans();

        console.log(self.search_floorPlan);


        // watch for check all checkbox
        self.$scope.$watch(function () {
            return self.checkboxes.checked;
        }, function (value) {


            jQuery.each(self.units, function (i, item) {
                // if (self.isUnitEditable(item)) {
                self.checkboxes.items[item.id] = value;
                // }
            });
        });

        // watch for data checkboxes
        self.$scope.$watch(function () {
            return self.checkboxes.items;
        }, function (values) {

        if(self.tableParams){
            var checked = 0, unchecked = 0, total = self.units.length;

            console.log(self.units);
            console.log(self.tableParams);
            let filteredData = self.tableParams.filter() ? self.filter('filter')(self.units, self.tableParams.filter()) : self.units;
            console.log(filteredData);
            jQuery.each(filteredData, function (i, item) {
                checked += (self.checkboxes.items[item.id]) || 0;
                unchecked += (!self.checkboxes.items[item.id]) || 0;
            });
            self.checkboxes.count = checked;

            if ((unchecked == 0) || (checked == 0)) {
               // self.checkboxes.checked = (checked == self.tableParams.data.length);
            }
        }
      

            // grayed checkbox
            angular.element(document.getElementsByClassName("select-all")).prop("indeterminate", (checked != 0 && unchecked != 0));
        }, true);


        //watch for search box changes
         
          self.$scope.$watch(function () {
            if(self.tableParams) {
            return self.tableParams.filter();
            }else {
            return;
            }
        }, function (values) {
               if(self.tableParams){
            var checked = 0, unchecked = 0, total = self.units.length;

            let filteredData = self.tableParams.filter() ? self.filter('filter')(self.units, self.tableParams.filter()) : self.units;

            jQuery.each(filteredData, function (i, item) {
                checked += (self.checkboxes.items[item.id]) || 0;
                unchecked += (!self.checkboxes.items[item.id]) || 0;
            });
            self.checkboxes.count = checked;

            if ((unchecked == 0) || (checked == 0)) {
                //self.checkboxes.checked = (checked == total);
            }
        }
      

            // grayed checkbox
            angular.element(document.getElementsByClassName("select-all")).prop("indeterminate", (checked != 0 && unchecked != 0));
        }, true);



        // SEARCH FILTERS CUSTOM IMPLEMENTATION
        self.$scope.$watch(function () {
            if(self.tableParams) {
                return self.tableParams.filter();
            }else {
                return;
            }
        }, function (values) {
         
        }, true);

        self.SSAnalyticsService.drawTotalViewsByProjectChart;
        self.getAllAgencies();

    }

    // sortUnits(sortBy, isAscending){
    //     const self = this;

    //     if(isAscending){
    //         self.units = _.sortBy(self.units, sortBy);
    //     }
    //     else{
    //         self.units = _.sortBy(self.units, sortBy).reverse();
    //     }
    //     self.loadUnits();
    // }

    sortData(column){
        const self = this;

        self.reverseSort = (self.sortColumn == column) ? !self.reverseSort : false;
        self.sortColumn = column;
    }

    getSortClass(column){
        const self = this;

        if(self.sortColumn == column){
            return self.reverseSort ? 'fa fa-caret-down' : 'fa fa-caret-up';
        }
    }

    applySearch(field){
        const self = this;

        self.unitsList = self.unitsBackup;

        if(!self.block_no_search && !self.unit_no_search && !self.category_search && !self.floor_plan_type_search 
          && !self.name_search && !self.price_type_search && !self.price_search && !self.psf_search){
            self.units = self.unitsBackup;
            self.loadUnits();
            return;
        }

        self.units = [];

        _.each(self.unitsList, function(unit){
          if(unit.block_no && self.block_no_search && startsWith(unit.block_no.toString(), self.block_no_search)){
            self.units.push(unit);
          }
          if(unit.named_id && self.unit_no_search && startsWith(unit.named_id, self.unit_no_search)){
            self.units.push(unit);
          }
          if(unit.formatted_category && self.category_search && startsWith(unit.formatted_category.trim().toLowerCase(), self.category_search.trim().toLowerCase())){
            self.units.push(unit);
          }
          if(unit.formatted_floor_plan_type && self.floor_plan_type_search && startsWith(unit.formatted_floor_plan_type.trim().toLowerCase(), self.floor_plan_type_search.trim().toLowerCase())){
            self.units.push(unit);
          }
          if(unit.name && self.name_search && startsWith(unit.name.trim().toLowerCase(), self.name_search.trim().toLowerCase())){
            self.units.push(unit);
          }
          if(unit.formatted_price_type && self.price_type_search && startsWith(unit.formatted_price_type.trim().toLowerCase(), self.price_type_search.trim().toLowerCase())){
            self.units.push(unit);
          }
          if(unit.price && self.price_search && startsWith(unit.price.toString(), self.price_search)){
            self.units.push(unit);
          }
          if(unit.psf && self.psf_search && startsWith(unit.psf.toString(), self.psf_search)){
            self.units.push(unit);
          }
        });
        self.loadUnits();
    }

    filterUnitsByStatus(status){
        const self = this;

        self.unit_status = status;

        if(!status){
            self.units = self.unitsBackup;
            self.loadUnits();
            return;
        }

        self.units = [];

        jQuery.each(self.unitsBackup, function(index, unit){
            if(unit.status == status){
                self.units.push(unit);
            }
        });
        self.loadUnits();
    }

    cancelChanges() {
        const self = this;

        loading(true);

        self.edited_status='';
        self.editable = !self.editable;
        self.edited_fields=[];
       // console.log(self.units_master);
       // console.log(self.units);
        self.units=angular.copy(self.units_master);
        self.initUnitsTable();
        self.SSAlertService.danger('Oops!', 'Your changes cancelled');
        self.changesApplied = false;

        loading(false);
    }

    getAllAgencies() {
        const self = this;

        self.agency_list = null;
        self.projectAgency =null;

        let url = 'agencies';


        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            if (!(response.data)) {
                return;
            }

            self.agency_list = response.data.agencies;
            self.getPropertyAgencies();
        });
    }

    goToAddCommission(unit){
        const self = this;

        self.$window.location = '/developer/properties/' + self.property.named_id + '/units/' + unit.id + '/commission-incentives';
    }

    goToUnitDetail(unit){
        const self = this;

        self.$window.location = '/developer/properties/' + self.property.named_id + '/units/' + unit.id + '/details';
    }

    getPropertyAgencies() {
        const self = this;
        self.agencyFormat = [];

        let url = 'sec/developer/agencies';

        let params = {
            property_id : self.param.property_id,
        };
        loading(true);
        self.SSHttpService.getAPIRequest(url,params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            if (!(response.data)) {
                return;
            }

            self.propery_agency_list = response.data.property_agencies;
            jQuery.each(self.propery_agency_list, function(i, agency){
                agency.name = self.agency_list.find(function (x) { return x.id == agency.agency_id; }).name;
                self.agencyFormat.push({id:agency.agency_id, label:agency.name});
            });
        });
    }


    getProperty() {
        const self = this;

        if (!self.data.property_id)
            return;

        self.property = null;

        let url = 'sec/developer/properties/' + self.data.property_id;

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.property = response.data.property;
            console.log('self.property');
            console.log(self.property);
            self.getUnits();
        });
    }

    showSelectedFields(field) {
        const self = this;

        self.editby=[];

        jQuery.each(self.OPTIONS_MAP, function (i, options){
            self.editby[options.value]=false;
        });
        if(field=="price"){
            self.price_show = true;
        }else {
            self.price_show = false;
        }
        self.editby[field]=true;

    }


    saveUnits(units){

        const self = this;

        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function (data) {
            self.save_units=[];
            self.save_units_data=[];
          //  self.save_units_incentives_data=[];
            self.edited_units=Array.from(new Set(self.edited_units));
            self.edited_status=null;

            jQuery.each(self.units, function(i, unit){

                if (jQuery.inArray(unit.id, self.edited_units) !== -1) {
                    self.save_units.push(unit);
                }
            });


            jQuery.each(self.save_units , function(i, unit){
                let units_data = {
                    "id":unit.id,
                    "floor_no":unit.floor_no,
                    "unit_no":unit.unit_no,
                    "type":unit.floorplan,
                    "category": unit.category,
                    "price": unit.price,
                    "floorplan_id" : unit.floor_plan_id,
                    "price_type": unit.price_type,
                    "name":unit.name,
                    "status":unit.status,
                };
                // let units_incentives_data = {
                //     "unit_id":unit.id,
                //     "agency_commission":unit.agencyCommission,
                //     "agent_incentive":unit.brokerIncentives,
                //    // "gst_inclusive": unit.gstInclusive,
                //    // "commission_gst_inclusive": unit.commissionGstInclusive,
                // };
                self.save_units_data.push(units_data);
               // self.save_units_incentives_data.push(units_incentives_data);

            });

            //console.log(self.save_units_data);
            //console.log(self.property.id);
            // return;


            // if(self.save_units_data){
            //   self.SSAlertService.danger('Please select the .');
            //}


            let importUrl = 'sec/developer/units/'+ self.property.id +'/json-update';
            let params = {
                propertyId: self.property.id,
                units_data: {"units": self.save_units_data},
               // commission_incentives_data: {"commission_incentives": self.save_units_incentives_data }

            };

            console.log(params);

            loading(true);
            self.SSHttpService.postAPIRequest(importUrl, params).then(function (response) {
                loading(false);

                if (response instanceof Error) {
                    if (response.code == 401) {
                        self.SSAlertService.danger('Oops!', 'Your session has expired. Please re-login to continue.');
                    } else if (response.code == 412) {
                        self.SSAlertService.danger('Invalid Params!', 'Please fill-in the valid information.');
                    } else {
                        self.SSAlertService.danger('Oops!', 'Please make changes and save');
                    }
                    return;
                }

                self.editable = !self.editable;

                jQuery.each(self.units, function(i, unit) {
                    self.checkboxes.items[unit.id] = false;
                    self.formatUnitData(unit);
                });

                self.edited_fields=[];
                self.units_master_converted=angular.copy(self.units);

                jQuery.each(self.save_units , function(i, unit){
                    if(unit.agencyId && unit.commission && unit.incentives && unit.commission_gst && unit.gst_inclusive) {
                        self.addUnitsCommission(unit);
                    }
                });

                self.SSAlertService.success('Success!', 'All data saved successfully.');

                self.changesApplied = false;
                self.progressUploadingFiles = false;
                console.log(response.data);

            });
        });

    }

    addUnitsCommission(unit){
        const self = this;
        self.newagency={};

        if(!unit)
            return;

        let url = 'sec/developer/agencies/setUnitCommission';
        self.registerErrors =null;
        let params = {

            unit_id: unit.id,
            agency_id: unit.agencyId,
            agency_commission: unit.commission,
            broker_incentives: unit.incentives,
            gst_inclusive: unit.commission_gst ? unit.commission_gst : null,
            commission_gst_inclusive: unit.gst_inclusive ? unit.gst_inclusive : null,
        };

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                self.registerErrors = self.SSHttpService.parseErrors(response);
                return;
            }

        });
    }


    updateFilter() {
        const self = this;

        self.offset = 0;
        self.retrieveApplications();
    }

    retrieveApplications() {

        const self = this;

        if (!self.data.property_id)
            return;

        self.stacks = [];
        self.units = [];
        self.units_master=[];
        self.edited_units=[];
        self.firstWatch=null;

        let url = 'sec/developer/properties/' + self.data.property_id + '/units';
        let params = {
            'limit': self.limit,
            'offset': self.offset,
            'agency_id' : 9,
            'send_total_count': true
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.stacks = response.data.stacks;
            self.units = response.data.property_units;
            

            jQuery.each(self.units, function (i, item) {
                self.$scope.$watchCollection(function () {
                    return self.units[i];
                }, function (newValue, oldValue) {

                    if ( self.firstWatch=="20" ) {
                        self.edited_units.push(newValue.id);
                    }

                });
            });

            self.units_master=angular.copy(self.units);

            self.initUnitsTable();


        });


    }

    getUnits() {
        const self = this;

        if (!self.property.id)
            return;

        self.stacks = [];
        self.units = [];
        self.units_master=[];
        self.edited_units=[];
        self.firstWatch=null;

        let url = 'sec/developer/properties/' + self.property.id + '/units';
        let params = {
            offset: 0,
            limit: 1500 // Consider max value
        };
        //,
        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.stacks = response.data.stacks;
            self.units = response.data.property_units;

            self.unitsBackup = response.data.property_units;

            self.count = self.unitsBackup.length;

            // self.unitsList = response.data.property_units;


            jQuery.each(self.units, function (i, item) {
                self.$scope.$watchCollection(function () {
                    return self.units[i];
                }, function (newValue, oldValue) {

                    if ( self.firstWatch=="20" ) {
                        self.edited_units.push(newValue.id);
                    }

                });
            });

            self.units_master=angular.copy(self.unitsList);

            // Comment this once new UI is implemented..
            self.units = response.data.property_units;
            jQuery.each(self.units, function (i, item) {
                self.$scope.$watchCollection(function () {
                    return self.units[i];
                }, function (newValue, oldValue) {

                    if ( self.firstWatch=="20" ) {
                        self.edited_units.push(newValue.id);
                    }

                });
            });

            self.units_master=angular.copy(self.units);
            self.initUnitsTable();
            // END: Comment this once new UI is implemented..

            // jQuery.each(self.unitsList, function (i, unit) {
            //     self.formatUnitData(unit);
            // });

            self.loadUnits();
        });
    }

    // CLIENT SIDE PAGINATION
    loadUnits(page){
        const self = this;

        // self.units = [];

        self.pages = Math.ceil(self.count / self.limit);
        self.selectedPage = Math.floor(self.offset / self.limit) + 1;
        self.pagesArr = [];

        // for (var i = 0; i < self.pages; i++) {
        //     self.pagesArr.push(i);
        // }
        // for(var i = 0; i < self.limit; i++){
        //     if(self.offset+i < self.count){
        //         let unit = self.unitsBackup[self.offset + i];
        //         self.units.push(unit);
        //     }
        // }

        if(page) {
            self.offset = (page * self.limit) - self.limit;
            self.current = page;
        }
    }

    // showPaginationDots(records){
    //     const self = this;

    //     if(records <= 10){
    //         return false;
    //     }
    //     else{
    //         return true;
    //     }
    // }

    // pagesGoBack() {
    //     const self = this;

    //     self.selectedPage--;
    //     self.offset = self.offset - self.limit;
    //     self.loadUnits();
    // }

    // pagesGoNext() {
    //     const self = this;

    //     self.selectedPage++;
    //     self.offset = self.offset + self.limit;
    //     self.loadUnits();
    // }

    // gotoPage(pageNum){
    //     const self = this;

    //     self.offset = parseInt(pageNum) * self.limit;
    //     self.loadUnits();
    // }

    watch_enable(field, id, field_name) {
        const self = this;

        let dirty_id=field_name+'_'+ id;


        if (jQuery.inArray(dirty_id, self.edited_fields) === -1) {
            self.edited_fields.push(dirty_id);
        }

        self.firstWatch ="20";
        self.edited_status="Changes has been made. Do you want to save?";
    }

    CheckFields(id, field) {
        const self = this;
        let dirty_id=field+'_'+ id;

        if (jQuery.inArray(dirty_id, self.edited_fields) !== -1) {
            return true;
        }
        return false;
    }
    initUnitsTable() {
        const self = this;

        jQuery.each(self.units, function (i, unit) {
            self.formatUnitData(unit);
        });

        self.checkboxes = {
            checked: false,
            count: 0,
            items: {}
        };

        self.select_status = [];

        self.tableParams = new self.NgTableParams({ page: 1,
            count: self.limit }, {dataset: self.units});

           

        self.units_master_converted=angular.copy(self.units);
    }

    searchArray(array, id) {
        const self = this;

        if (!array || !id) return '';

        if (typeof array == "string") {
            array = self.serverConfig[array];
        }
        let object = null;
        jQuery.each(array, function(i, e) {
            if (e.id == id) {
                object = e;
            }
        });

        return object ? object.name : '';
    }
    formatUnitData(unit) {
        const self = this;

        unit.formatted_unit_no = self.SSUtilService.getFullUnitNumber(unit);

        unit.formatted_category = self.SSConfigService.getUnitCategoryName(unit.category);
        unit.formatted_type = self.SSConfigService.getUnitTypeName(unit.type);
        unit.formatted_category = self.SSConfigService.getUnitCategoryName(unit.category);
        unit.formatted_status = self.SSConfigService.getUnitStatusName(unit.status);
        unit.formatted_price_type = self.SSConfigService.getUnitPriceTypeName(unit.price_type);
        unit.formatted_floor_plan_type = unit.floor_plan ? unit.floor_plan : '';
        // unit.formatted_floor_plan_type = self.searchArray(self.floorPlans, unit.floor_plan_id);
        unit.actual_price = unit.price;

        let stack = self.findStack(unit.stack_id);
        if (stack) {
            unit.block_no = stack.block_no;
            unit.stack_name = stack.name;
        }

        return unit;
    }

    findStack(stackId) {
        const self = this;

        let stack = null;

        jQuery.each(self.stacks, function (i, _stack) {
            if (stackId == _stack.id) {
                stack = _stack;
                return false;
            }
        });

        return stack;
    }

    viewUnit(unit) {
        const ctrl = this;

        self.$window.location.href = '/developer/properties/' + ctrl.property.named_id + '/units/' + unit.named_id;
    }

    isUnitEditable(unit) {
        const self = this;
        return unit.status == self.UNIT_STATUS_DRAFT || unit.status == self.UNIT_STATUS_LISTED || unit.status == self.UNIT_STATUS_SOLD;
    }

    getKitchenType(unit){
        const self = this;

        if(!unit){
            return '--';
        }
        let kitchen_type = self.SSConfigService.getUnitKitchenTypeName(unit.kitchen_type);

        // dry_kitchen variable can have values 0, 1, 2 upto x
        // 0 -> no dry kitchen
        // value 1 or above -> number of kitchens 
        if(unit.dry_kitchen){
            kitchen_type += ' - Dry Kitchen';
            if(unit.dry_kitchen > 1){
                kitchen_type += ' ' + unit.dry_kitchen;
            }
        }
        return kitchen_type;
    }

    getDate(unit){
        const self = this;

        try{
            let date = unit.updated_at ? unit.updated_at : unit.created_at;
            if(date){
                return self.SSUtilService.formatUtcToLocalDate(date) + " " + self.SSUtilService.formatUtcToLocalTime(date);
            }
            else{
                return '--';
            }
        }
        catch(ex){
            console.log(ex);
        }
    }

    applyChanges() {
        const self = this;
        self.SSAlertService.success('');

        self.param.unit_ids = [];
        let filteredData = self.tableParams.filter() ? self.filter('filter')(self.units, self.tableParams.filter()) : self.units;
        self.agencyIdSelected =[];
        jQuery.each(self.selectedAgency, function (i, agency) {
            self.agencyIdSelected.push(agency.id);
        });

        jQuery.each(filteredData, function (i, item) {
            if (self.checkboxes.items[item.id] == true) {
                self.param.unit_ids.push(item.id);
                self.edited_units.push(item.id);
                console.log("conv"+self.units_master_converted);
                jQuery.each(self.units, function (i, unit) {

                    if(unit.id==item.id) {

                        if(self.param.update_price_by==="1"){
                            unit.price=self.param.price;
                        }else if(self.param.update_price_by==="2") {
                            if(self.param.price!=="undefined" && self.param.price !== null && self.param.price !== "") {
                                console.log("price"+self.param.price);
                                let x = parseFloat(Number((self.param.price / 100) * self.units_master_converted[i].price).toFixed(2));
                                let y = parseFloat(Number(self.units_master_converted[i].price).toFixed(2));
                                unit.price=x+y;
                            }
                            else {
                                unit.price=self.param.price;
                            }
                        }else if(self.param.update_price_by==="3") {
                            if(self.param.price!=="undefined" && self.param.price !== null && self.param.price !== "") {
                                let y = parseFloat(Number(self.units_master_converted[i].price).toFixed(2));
                                unit.price=self.param.price+y;
                            }
                        } else if(self.param.update_price_by==="4") {
                            if(self.param.price!=="undefined" && self.param.price !== null && self.param.price !== "") {
                                let y = parseFloat(Number(self.units_master_converted[i].price).toFixed(2));
                                unit.price=y-self.param.price;
                            }
                        }

                        if(self.selectedAgency.length > 0) {

                            unit.agencyId = self.agencyIdSelected.join();
                            unit.commission = self.param.commission;
                            unit.incentives = self.param.broker_incentives_add;
                            unit.commission_gst = self.param.commission_gst
                            unit.gst_inclusive = self.param.gst_inclusive;
                        }

                        if(self.param.category) {
                            unit.category = self.param.category;
                        }

                        if(self.param.type) {
                            unit.type = self.param.type;
                        }
                        if(self.param.name) {
                            unit.name = self.param.name;
                        }
                        if(self.param.pricetype) {
                            unit.pricetype = self.param.pricetype;
                        }
                        if(self.param.status) {
                            unit.status = self.param.status;
                        }
                    }
                    self.formatUnitData(unit);

                });
                jQuery.each(self.param, function (i, field) {
                    let dirty_id = i + '_' + item.id;


                    if (jQuery.inArray(dirty_id, self.edited_fields) === -1) {
                        self.edited_fields.push(dirty_id);
                    }

                });
            }
        });

        //console.log(self.edited_units);



        if (self.param.unit_ids.length == 0) {

            self.SSAlertService.danger('Please select unit(s) to apply changes.');
            return;
        } else if (!self.param.name
            && !self.param.price
            && !self.param.status
            && !self.param.category
            && !self.param.type
            && !self.selectedAgency.length > 0
        ) {
            console.log("error_reporting");

            self.SSAlertService.danger('Please provide correct value for at least one attribute (Price, Status, Name, Category, Type) to update unit(s).');
            return;
        }
        else {
            self.SSAlertService.success("Changes applied, Please click save");
        }

        if(self.selectedAgency.length > 0){
            if(!self.param.commission || !self.param.broker_incentives_add){
                self.SSAlertService.danger('Please provide commission and incentives for selected agency.');
                return;
            }

            if(!self.param.commission_gst || !self.param.gst_inclusive){
                self.SSAlertService.danger('Please select GST for commission and incentives.');
                return;
            }

        }

        self.changesApplied = true;

        /*else if (self.hours_expire_after_otp && (self.hours_expire_after_otp < 1 || self.hours_expire_after_otp > 48)) {

         self.SSAlertService.danger('Please provide correct value for OTP Timeout between 1 to 48 hours.');
         } else {

         self.SSAlertService.clear();
         jQuery('#confirm_modal').modal('show');
         }  */
    }


    selectedAlert() {
        const self = this;


        if (self.checkboxes.checked == true) {
            self.edited_status = "Changes will be applied to " + self.units.length + " rows";
        }else if(self.checkboxes.checked == false){
            self.edited_status = '';
        }
    }

    exportUnits(id){
        const self = this;
        let url = "sec/developer/properties/"+id+"/export";
        url = self.SSHttpService.getApiURL(url);
        console.log(url);
        self.$window.location.href  = url;
    }

    toggleCheckAll(){
        const self = this;

        if(self.checkAll){
            // All units checked
            // self.selected_units = self.unitsList.length;
            // $('.unit_checkbox').prop('checked', true);
            jQuery.each(self.units, function (i, item) {
                self.checkboxes.items[item.id] = true;
            });
            let checked = self.units.length;
            self.edited_status = "Changes will be applied to " + checked + " rows";
        }
        else{
            // self.selected_units = 0;
            // $('.unit_checkbox').prop('checked', false);
            jQuery.each(self.units, function (i, item) {
                self.checkboxes.items[item.id] = false;
            });
            self.edited_status = "";
        }
    }

    // checkedAlert(unit) {
    //     const self = this;

    //     console.log('event');
    //     console.log(event);

    //     if(self.checkboxes.items[unit.id] == false){
    //         self.selected_units = self.selected_units - 1;
    //         self.checkboxes.items[unit.id] == true;
    //     }
    //     else if(self.checkboxes.items[unit.id] == true){
    //         self.selected_units = self.selected_units + 1;
    //         self.checkboxes.items[unit.id] == false;
    //     }
        

    //     // // console.log(self.units);
    //     // jQuery.each(self.units, function (i, item) {
    //     //     checked += (self.checkboxes.items[item.id]) || 0;
    //     //     unchecked += (!self.checkboxes.items[item.id]) || 0;
    //     // });

    //     // self.edited_status = "Changes will be applied to " + checked + " rows";
    // }

    checkedAlert(unit) {
        const self=this;

        let checked=null;
        let unchecked=null;

        if(self.checkboxes.items[unit.id] == false){
            self.checkboxes.items[unit.id] == true;
        }
        else if(self.checkboxes.items[unit.id] == true){
            self.checkboxes.items[unit.id] == false;
        }

        // console.log(self.units);
        jQuery.each(self.units, function (i, item) {
            checked += (self.checkboxes.items[item.id]) || 0;
            unchecked += (!self.checkboxes.items[item.id]) || 0;
        });

        console.log('self.checkboxes.items');
        console.log(self.checkboxes.items);
        self.edited_status = "Changes will be applied to " + checked + " rows";
    }

    addCommissionIncentives() {
        jQuery('#add_incentives').modal('show');
    }

    confirmApply() {
        const self = this;

        jQuery('#confirm_modal').modal('hide');

        self.OTPService.getVerified(function (data) {
            self._confirmApply(data);
        }, self.OTPService.TYPE_SESSION_2FA);
    }

    _confirmApply() {
        const self = this;


        console.log("selfparam"+self.param);

        let url = 'sec/developer/units/bulk-update';

        loading(true);
        self.SSHttpService.postAPIRequest(url, self.param).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            let updatedUnits = response.data.units;

            jQuery.each(updatedUnits, function (i, updatedUnit) {
                let oldUnit = self.SSUtilService.findValueFromArray(self.units, 'id', updatedUnit.id);
                angular.merge(oldUnit, updatedUnit);
                self.formatUnitData(oldUnit);
            });

            self.tableParams.reload();
            self.checkboxes = {
                checked: false,
                count: 0,
                items: {}
            };

            self.SSAlertService.success('Data has been updated successfully.');
        });
    }

    // Units Import

    importUnits() {
        const self = this;

        if (!self.importParams.unitsExcelFile) {
            return;
        }

        self.OTPService.getVerified(
            self.OTPService.TYPE_SESSION_2FA,
            function () {
                self.uploadUnitsExcel(self.importParams.unitsExcelFile);
            }
        );
    }

    getFloorPlans() {
        const self = this;

    }

    uploadUnitsExcel(file) {
        const self = this;

        self.progressUploadingFiles = true;
        self.filesUploadProgress = 0;

        loading(true);
        self.Upload.upload({
            url: self.SSHttpService.getApiURL('sec/developer/import/units/parse'),
            method: 'POST',
            data: {
                import_file: file
            },
            withCredentials: true
        }).then(function (response) {
            loading(false);
            self.progressUploadingFiles = false;

            response = response.data ? response.data : {};

            if (response.code !== 200) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            if (!response.data.units) {
                self.SSAlertService.danger('Error!', 'Invalid or empty file.');
                return;
            }

            self.importData = response.data;

            if (self.importParams.unitsAssetFiles && self.importParams.unitsAssetFiles.length) {
                self.uploadUnitFiles(self.importParams.unitsAssetFiles);
            } else {
                self._importUnits();
            }

        }, function (response) {

            self.progressUploadingFiles = false;
            self.SSAlertService.parseAndDisplayError(response);

        }, function (evt) {
        });
    }

    uploadUnitFiles(files) {
        const self = this;

        if (!files) return;

        let policyUrl = 'sec/developer/import/properties/s3-policy-document';
        let processedFiles = 0;

        self.assets = {};
        self.progressUploadingFiles = true;
        self.filesUploadProgress = 0;

        loading(true);
        self.SSAwsService.policyAPIRequest(policyUrl, function (policy) {
            loading(false);

            jQuery.each(files, function (i, file) {
                self.SSAwsService.upload(file, policy, function (response) {

                    if (response instanceof Error) {
                        if (response.code == 401) {
                            self.SSAlertService.danger('Oops!', 'Your session has expired. Please re-login to continue.');
                        } else if (response.code == 412) {
                            self.SSAlertService.danger('Invalid Params!', 'Please fill-in the valid information.');
                        } else {
                            self.SSAlertService.danger('Oops!', 'Something went wrong. Please contact support.');
                        }
                        return;
                    }
                    self.SSAlertService.success('Success!', 'Assets uploaded successfully.');

                    self.assets[response.config.data.file.name] = response.config.data.key;
                    processedFiles += 1;

                    self.filesUploadProgress = parseInt(100.0 * processedFiles / files.length);

                    if (processedFiles == files.length) {
                        self._importUnits();
                    }
                });
            });
        });
    }

    _importUnits() {
        const self = this;

        let importUrl = 'sec/developer/import/units';

        let params = {
            property_id: self.property.id,
            units: self.importData.units,
            assets: self.assets
        };

        loading(true);
        self.SSHttpService.postAPIRequest(importUrl, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                if (response.code == 401) {
                    self.SSAlertService.danger('Oops!', 'Your session has expired. Please re-login to continue.');
                } else if (response.code == 412) {
                    self.SSAlertService.danger('Invalid Params!', 'Please fill-in the valid information.');
                } else {
                    self.SSAlertService.danger('Oops!', 'Something went wrong. Please contact support.');
                }
                return;
            }

            self.SSAlertService.success('Success!', 'All data is imported successfully.');

            self.progressUploadingFiles = false;

            // Update local data
            jQuery.each(response.data.units, function (i, unit) {
                self.formatUnitData(unit);

                let oldUnit = self.SSUtilService.findValueFromArray(self.units, 'id', unit.id)
                if (oldUnit) {
                    angular.merge(oldUnit, unit);
                } else {
                    self.units.push(unit);
                }
            });

            self.showImport = false;
            self.tableParams.reload();
            self.checkboxes = {
                checked: false,
                count: 0,
                items: {}
            };
        });
    }

    // Units Import


    deleteUnit(unit_id){
        const self = this;
        if (!self.property.id) {
            return;
        }
        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to delete this unit?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                let url = 'sec/developer/properties/' + self.property.id + '/'+unit_id+'/delete';
                loading(true);
                self.SSHttpService.postAPIRequest(url).then(function (response) {
                    loading(false);
                    if (response instanceof Error) {
                        self.SSAlertService.danger('Error! :',response.message);
                        return;
                    }
                    else{
                        self.getUnits();
                        self.SSAlertService.success('Success! :',response.message);
                    }
                });
            }
        );



    }

}

UnitIndexBackupController.$inject = ['$scope', '$window', '$filter', 'Upload', 'SSHttpService', 'SSConfigService', 'SSAlertService', 'SSUtilService', 'OTPService', 'SSAppService', 'NgTableParams', 'SSAwsService', 'SSUserService','SSAnalyticsService','SSConfirmationService'];
app.controller('UnitIndexBackupController', UnitIndexBackupController);